import { styled } from "@mui/system";
// import Button from "@mui/material/Button";

export const ResultContainer = styled("div")({
  padding: "0 15vw",
  marginBottom: "150px",

  "@media (max-width: 1178px)": {
    padding: "0 10vw",
  },
  "@media (max-width: 1056px)": {
    padding: "0 5vw",
  },
});

export const TitleContainer = styled("div")({
  display: "flex",
  alignItems: "center",
});

export const TitleIcon = styled("img")({
  marginRight: 20,
  fontSize: 30,
});

export const ResultTitle = styled("h1")({
  textAlign: "center",
  fontWeight: 500,
  marginBottom: 80,
  fontsize: 18,
});

export const ResultDetailed = styled("p")({
  textAlign: "justify",
});

export const ResultTop = styled("div")({
  display: "flex",
  alignItems: "flex-start",
  marginBottom: 40,

  "@media (max-width: 1018px)": {
    flexDirection: "column-reverse",
  },
});

export const DetailContainer = styled("div")({
  flex: 0.4,
  marginRight: "auto",

  "@media (max-width: 1018px)": {
    margin: "0 auto",
  },
});

export const DetailBox = styled("div")({
  marginBottom: 20,
});

export const ResultBox = styled("div")({
  flex: 0.5,
  backgroundColor: "#EFF0F2",
  minHeight: "50vh",
  borderRadius: "30px 0",
  boxShadow: "1px 2px 6px rgba(0, 0, 0, 0.2)",

  "@media (max-width: 1018px)": {
    flex: 1,
    margin: "0 auto",
    marginBottom: 80,
  },
});

export const Titled = styled("h4")({
  fontWeight: 600,
  fontSize: "20px",
  fontFamily: "Open Sans",
  marginBottom: "10px",
  marginTop: 10,
});

export const ResultTitled = styled("h2")({
  textAlign: "center",
  fontWeight: 600,
  fontSize: "20px",
  fontFamily: "Open Sans",
  marginBottom: "20px",
  textTransform: "capitalize",
});

export const DetailTitle = styled("h2")({
  fontWeight: 600,
  fontSize: "16px",
  fontFamily: "Open Sans",
  textAlign: "center",
});

export const DetailListContainer = styled("ul")({
  // marginTop: 10,
  listStyleType: "none",
});

export const ResultImg = styled("div")({
  height: "40vh",
  borderRadius: "29px 0 0 0",
});

export const FeatureImg = styled("img")({
  width: "100%",
  height: "100%",
  display: "block",
  objectFit: "cover",
  borderRadius: "29px 0 0 0",
});

export const CtaBox = styled("div")({
  padding: "30px 50px",

  "@media (max-width: 413px)": {
    padding: "20 30px",
  },
  "@media (max-width: 351px)": {
    padding: "20 0px",
  },
});

export const TopTitle = styled("h1")({
  fontFamily: "Cormorant",
  fontSize: 35,
  textAlign: "center",
  fontWeight: 400,
  marginBottom: 30,
});

export const ListItem = styled("li")({
  fontSize: 14,
  marginBottom: 1,
  fontFamily: "Open Sans",
  textAlign: "justify",
});

export const ButtonBox = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-around",
  marginTop: 20,
  padding: "0 40px",

  "@media (max-width: 540px)": {
    padding: "0 30px",
  },

  "@media (max-width: 464px)": {
    padding: "0 10px",
  },

  "@media (max-width: 413px)": {
    padding: "0 0px",
  },
});

export const ButtonContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  marginTop: 20,
  "@media (max-width: 540px)": {
    padding: "0 30px",
  },

  "@media (max-width: 464px)": {
    padding: "0 10px",
  },

  "@media (max-width: 413px)": {
    padding: "0 0px",
  },
});

export const TransparentBtnCta = styled("a")({
  width: 155,
  border: "2px solid #000000",
  fontSize: 14,
  color: "#000000",
  padding: "14px 0",
  borderRadius: 30,
  fontWeight: 500,
  textTransform: "capitalize",
  textAlign: "center",
  cursor: "pointer",

  "@media (max-width: 413px)": {
    width: 100,
    fontSize: 10,
    padding: "8px 0",
  },

  "&:hover": {
    color: "#000000",
  },
});

export const FilledBtnCta = styled("a")({
  width: 140,
  fontSize: 14,
  color: "#fff",
  padding: "16px 0",
  borderRadius: 30,
  backgroundColor: "#5E9C98",
  fontWeight: 500,
  textTransform: "capitalize",
  boxShadow: "1px 2px 6px rgba(0, 0, 0, 0.2)",
  textAlign: "center",
  "&:hover": {
    backgroundColor: "#5E9C98",
  },

  "@media (max-width: 413px)": {
    width: 100,
    fontSize: 10,
    padding: "10px 0",
  },
});

export const MatchBox = styled("div")({
  display: "flex",
  alignItems: "flex-start",
  marginBottom: 40,

  "@media (max-width: 566px)": {
    flexDirection: "column",
    // justifyContent: "flex-start",
  },
});

export const MatchImg = styled("div")({
  height: 245,
  width: 340,
  borderRadius: 15,

  "@media (max-width: 566px)": {
    margin: "0 auto",
    marginBottom: 30,
  },
});

export const MoreImages = styled("img")({
  width: "100%",
  height: "100%",
  display: "block",
  objectFit: "cover",
  borderRadius: 15,
});

export const MatchDetail = styled("div")({
  width: 700,
  marginLeft: 50,
  textAlign: "justify",

  "@media (max-width: 584px)": {
    marginLeft: 20,
  },
  "@media (max-width: 566px)": {
    margin: "0 auto",
  },

  "@media (max-width: 370px)": {
    width: 310,
  },
});

export const MatchTitle = styled("h3")({
  fontWeight: 600,
  fontSize: 20,
  fontFamily: "Open Sans",
  color: "#000000",
  margin: 0,
  textTransform: "capitalize",
});

export const MatchList = styled("ul")({
  // marginTop: 30,
  // paddingLeft: 30,
  // marginBottom: 20,
});

export const MatchListItem = styled("p")({
  fontSize: 15,
  marginBottom: 1,
  listStyleType: "none",
  margin: 0,
  textAlign: "justify",
});
